import request from '@/utils/request'

// 获取一级标签
export function getGrateOne(videoGrade,status) {
    const param = {
        videoGrade : videoGrade,
        status:status
    }
    return request({
        url: '/type/type/gradelist',
        headers: {
            isToken: true,
            'Content-Type': 'application/json' // 强制用json
        },
        params: param,
        method: 'get'

    })
}

// 获取二级标签（根据 parentId）
export function getSubTypes(parentId,status) {
    const param = {
        parentId :parentId,
        status:status
    }
    return request({

        url: '/type/type/parendList',
        method: 'get',
        params: param // 查询 parentId 的子类
    })
}

// 获取课程列表（根据 typeId）
export function getCoursesByType(params) {
    return request({
        url: '/videos/videos/videoAppList',
        method: 'get',
        params: params
    })
}


// 获取我能观看的课程列表（根据 typeId）

export function getMyClass(params) {
    return request({
        url: '/purchase/purchase/videoPurchaseList',
        method: 'get',
        params: params
    })
}
// 获取是否是免费视频，以及我能观看的课程列表，判断能否播放（根据 params）

export function checkWatch(params) {
    return request({
        url: '/videos/videos/checkWatch',
        method: 'get',
        params: params
    })
}